import React, { useEffect, useState } from 'react';
const NAMES = ['Lukas', 'Markus', 'Stefan', 'Andreas', 'Thomas', 'Michael', 'Julian', 'Sebastian', 'Daniel', 'Tobias', 'Anna', 'Lena', 'Sarah', 'Julia', 'Katharina'];
const CITIES = ['Berlin 🇩🇪', 'München 🇩🇪', 'Hamburg 🇩🇪', 'Köln 🇩🇪', 'Frankfurt 🇩🇪', 'Stuttgart 🇩🇪', 'Düsseldorf 🇩🇪', 'Leipzig 🇩🇪', 'Dresden 🇩🇪', 'Bremen 🇩🇪', 'Hannover 🇩🇪', 'Nürnberg 🇩🇪'];
const PRODUCTS = [{
  name: 'Volleyball Bereit Kit',
  emoji: '🏐'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 45000 + Math.floor(Math.random() * 30000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed top-4 right-4 sm:top-6 sm:right-6 z-50 transition-[transform,opacity] duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-210">
      <div className="bg-bg-alt border border-border-light rounded-2xl shadow-xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-211">
        <button onClick={() => setIsDismissed(true)} className="absolute top-3 right-3 text-text-sec hover:text-white transition-colors p-1" aria-label="Benachrichtigung schließen" data-id="element-212">
          ✕
        </button>

        <div className="flex items-center gap-3 mb-3" data-id="element-213">
          <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner" data-id="element-214">
            <span className="text-sm" data-id="element-215">👤</span>
          </div>
          <span className="text-text-main text-sm font-bold" data-id="element-216">
            {notification.name} {notification.initial}.{' '}
            <span className="text-text-sec font-normal ml-1 text-xs" data-id="element-217">
              aus {notification.city}
            </span>
          </span>
        </div>

        <p className="text-text-main text-sm mb-2 leading-tight font-medium" data-id="element-218">
          Hat gerade{' '}
          <span className="text-primary font-bold" data-id="element-219">
            {notification.product.name}
          </span>{' '}
          gekauft {notification.product.emoji}
        </p>

        <div className="flex items-center gap-2 mt-3 pt-2 border-t border-border-light/50" data-id="element-220">
          <div className="w-2 h-2 bg-check-green rounded-full shadow-[0_0_8px_rgba(16,185,129,0.8)]" data-id="element-221"></div>
          <p className="text-text-sec text-[10px] font-bold uppercase tracking-wider" data-id="element-222">
            Verifizierter Kauf · vor {notification.timeAgo} Min.
          </p>
        </div>
      </div>
    </div>;
}